/** @format */

import { ChangeDetectionStrategy, Component, computed, input, model } from '@angular/core';

import { DCSG_CONSTANTS } from '@shared/data-access/constants';

@Component({
  selector: 'plp-components-category-bubble',
  templateUrl: './category-bubble.component.html',
  styleUrl: './category-bubble.component.scss',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CategoryBubbleComponent {
  image = model.required<string>();
  link = input.required<string>();

  altText = input('');
  label = input('');

  readonly displayImage = computed(() => this.image() || DCSG_CONSTANTS.imageUnavailable);

  imageError(): void {
    this.image.set(DCSG_CONSTANTS.imageUnavailable);
  }
}
